export const adminDeleteLoader = (state = false, action) => {
  switch (action.type) {
    case "SHOW_DELETE_LOADER_ADMIN":
      return true
    case "HIDE_DELETE_LOADER_ADMIN":
      return false
    default:
      return state
  }
}
